import FunnelChart from '../../components/admin/FunnelChart';
import TimeSeriesChart from '../../components/admin/TimeSeriesChart';
import useAdminData from './useAdminData';
import { fetchFunnelIT, fetchGhostLeadsSeries } from '../../services/adminStatsService';

export default function AdminFunnel() {
  const funnel = useAdminData(fetchFunnelIT);
  const ghost = useAdminData(fetchGhostLeadsSeries);

  const steps = funnel.data
    ? [
        { label: 'Conversations (IT)', value: funnel.data.total },
        { label: 'With token', value: funnel.data.withToken },
        { label: 'With lead generated', value: funnel.data.withLeadId },
        { label: 'Closed', value: funnel.data.closed },
      ]
    : [];

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Funnel IT (proxy via leadId)</h3>
        {funnel.loading ? (
          <div className="text-gray-500 text-sm">Loading…</div>
        ) : funnel.error ? (
          <div className="text-red-600 text-sm">{funnel.error}</div>
        ) : (
          <FunnelChart steps={steps} />
        )}
        <p className="text-xs text-gray-500 mt-3">
          Note: state machine steps (age → gender → smoker → capital) are not logged in the DB — this funnel is a
          proxy based on <code className="bg-gray-100 px-1 rounded">token</code> and{' '}
          <code className="bg-gray-100 px-1 rounded">leadId</code> columns of the conversation.
        </p>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Ghost leads (ES) per day</h3>
        {ghost.loading ? (
          <div className="text-gray-500 text-sm">Loading…</div>
        ) : ghost.error ? (
          <div className="text-red-600 text-sm">{ghost.error}</div>
        ) : (
          <TimeSeriesChart
            data={ghost.data?.data || []}
            series={[{ key: 'count', label: 'Ghost leads' }]}
          />
        )}
      </div>
    </div>
  );
}
